function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Mobile-default",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "iPhone-11",
  transform: "translate(-223.000000, -527.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Fill-6",
  transform: "translate(223.000000, 527.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19,15.5 C19,15.892 18.567,16.13 18.235,15.924 L15,13.901 L15,16.499 C15,16.775 14.776,16.999 14.5,16.999 L5.5,16.999 C5.224,16.999 5,16.775 5,16.499 L5,7.499 C5,7.223 5.224,6.999 5.5,6.999 L14.5,6.999 C14.776,6.999 15,7.223 15,7.499 L15,10.098 L18.235,8.075 C18.565,7.868 19,8.106 19,8.5 L19,15.5 Z M12,0 C5.383,0 0,5.383 0,12 C0,18.616 5.383,24 12,24 C18.617,24 24,18.616 24,12 C24,5.383 18.617,0 12,0 L12,0 Z",
  id: "Fill-1"
}))));

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.e559be99.svg";
export { ForwardRef as ReactComponent };